export default __webpack_public_path__ + "static/media/plus-icon.e0c851a2.svg";